import { cn } from "@hireart/component-library";
import PropTypes from "prop-types";

export const Description = ({ children, className = undefined }) => {
  return <dd className={cn("mb-32 ms-0", className)}>{children}</dd>;
};

Description.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
